export default __webpack_public_path__ + "static/media/4577084917d367031d2a189d4e7585461575648519721.ca928f42.webp";